import React from 'react';
import './ImatCourse.css';
import studyImage from "../assets/enrollmee.jpg"; // Replace with your image file
import planner from "../assets/planner.jpg"; // Replace with your image file
import pnotes from "../assets/pnotes.jpg"; // Replace with your image file
import bnotes from "../assets/biology2.jpg"; // Replace with your image file
import cnotes from "../assets/cnotes.jpg"; // Replace with your image file
import mnotes from "../assets/mnotes.jpg"; // Replace with your image file
import rnotes from "../assets/rnotes.png"; // Replace with your image file
import backgroundVideo from "../assets/frontvideo.mp4"; // Place this video in the public folder or src
import { useNavigate } from 'react-router-dom';



const ImatCourse = () => {
  const navigate = useNavigate();

  const handleEnrollClick = () => {
    navigate('/aboutus'); // Use navigate instead of window.location.href
  };


  return (
    <>
      <div className="hero-container">
        <video autoPlay loop muted className="background-video">
          <source src={backgroundVideo} type="video/mp4" />
          Your browser does not support the video tag.
        </video>
        <div className="hero-content">
          <h1>MEDItalia IMAT Preparation Course</h1>
          <p>
            Pass the IMAT and secure your spot in Italian medical schools with
            future medsacademy’s most comprehensive, cost-effective online
            course! It has everything a future doctor needs from start to finish.
          </p>
          <div className="hero-buttons">
            <button
              className="join-btn"
              id="loginBtn"
              onClick={() => (window.location.href = 'https://mocktest.futuremedsacademy.com/')}
            >
              Join Us
            </button>
            <button className="whats-new-btn">WHAT'S NEW</button>
          </div>
        </div>
      </div>

      <div className="study-container">
        <div className="study-content">
          <p className="study-subtitle">Know About the Founder</p>
          <h1 className="study-title">
            Crack The IMAT with FMA <span className="highlight">with 108+  hours of Live Lecture and 200+ hours of recorded content</span>
          </h1>
          <ul className="study-list">
            <li>✔ <b>Live Lectures and Recorded Lecture</b></li>
            <li>✔ <b>12-major mock test</b></li>
            <li>✔ <b>6-live minor test</b></li>
            <li>✔ <b>Subjective test</b></li>
            <li>✔ <b>Mentorship guidance from student's studying in Italy.</b></li>
            <li>✔ <b>Notes and important questions of IMAT</b></li>
            <h1><b>Personal support with Amir Akhtar incase of emotional stress and financial difficulties</b></h1>
            {/* <li>✔ <b>3 years of work</b> and still constantly updating based on feedback.</li> */}
          </ul>
          <button className="study-btn" onClick={handleEnrollClick}>About Amir Akhtar</button>
        </div>
        <div className="study-image">
          <img src={studyImage} alt="Study Session" />
        </div>
      </div>

      <div className="study-container">
        <div className="study-image">
          <img src={planner} alt="Study Session" />
        </div>
        <div className="study-content">
          <p className="study-subtitle">EVERYTHING YOU NEED FROM START TO FINISH</p>
          <h1 className="study-title">
            Exam preparation with proper planner <span className="highlight">Your future our goal start with FMA today</span>
          </h1>
          <ul className="study-list">
            <li>✔ <b>Student track and - allocation of personal coach.</b></li>
            <li>✔ <b>IMAT past year detailed videos on problem solving, logical reasoning.</b></li>
            <h1><b>Recorded lecture of physics, chemistry, biology and mathematics even though they are live.</b></h1>
          </ul>
          <button
            className="btn"
            id="loginBtn"
            onClick={() => (window.location.href = 'https://mocktest.futuremedsacademy.com/pricing')}
          >
            Enroll Now
          </button>
        </div>
      </div>

      <div className="study-container">
        <div className="study-content">
          <p className="study-subtitle">Master IMAT Physics with Aamir Akhtar</p>
          <h1 className="study-title">
            <span className="highlight">Physics</span>
          </h1>
          <p className="study-subtitle">Why Choose Our Physics Course?</p>
          <h1><b>Excel in IMAT Physics with a Structured & Strategic Approach
            Physics is often considered one of the most challenging sections of the IMAT exam.

          </b></h1>

          <p><b>At Future MedsAcademy, we ensure that you gain conceptual clarity and problem-solving expertise to tackle even the toughest questions with confidence.



          </b></p>
          <ul className="study-list">
            <li>✔ <b>Concept-Based Learning – Go beyond memorization and develop a deep understanding of formulas, laws, and problem-solving techniques.
            </b></li>
            <li>✔ <b>Recorded Lectures for Revision – Never miss a class! All sessions are recorded and available exclusively to Plus & Premium students for unlimited access.
            </b></li>
            <li>✔ <b> IMAT-Focused Problem-Solving – Learn how to approach real IMAT-style physics questions with strategic methods and shortcuts.</b></li>
            <li>✔ <b> High-Yield Syllabus Coverage – Focus on essential topics frequently tested in IMAT, ensuring no time is wasted on unnecessary content.</b></li>
          </ul>
          <button
            className="btn"
            id="loginBtn"
            onClick={() => (window.location.href = 'https://mocktest.futuremedsacademy.com/pricing')}
          >
            Enroll Now
          </button>
        </div>
        <div className="study-image">
          <img src={pnotes} alt="Study Session" />
        </div>
      </div>

      <div className="study-container">
        <div className="study-image">
          <img src={bnotes} alt="Study Session" />
        </div>
        <div className="study-content">
          <p className="study-subtitle">Ace IMAT Biology with Talal Adil
          </p>
          <h1 className="study-title">
            <span className="highlight">Biology</span>
          </h1>
          <p className="study-subtitle">Why Choose Our Biology Course?</p>
          <h1><b>Learn from an Expert with 2 Years of IMAT Teaching Experience
            Biology forms the largest portion of the IMAT exam, and mastering it requires the right strategies, smart study techniques, and expert guidance.



          </b></h1>

          <p><b>Talal Adil, a university student in the Netherlands, has been teaching IMAT Biology for 2 years, helping students grasp complex biological concepts with clarity and excel in the exam with confidence.



          </b></p>
          <ul className="study-list">
            <li>✔ <b> 2 Years of Proven IMAT Teaching Experience – Learn from someone who knows what works.


            </b></li>

            <li>✔ <b>University Student in the Netherlands – First-hand experience in international medical education.

            </b></li>
            <li>✔ <b> Focus on High-Yield IMAT Topics – Covering key concepts that are most frequently tested.

            </b></li>
            <li>✔ <b>  Simplified Learning Methods – Biology made easy with structured lessons, diagrams, and quick revision notes.

            </b></li>

            <li>✔ <b>Interactive Live Classes + Recorded Sessions – Learn at your pace, with doubt-clearing sessions.

            </b></li>
          </ul>
          <button
            className="btn"
            id="loginBtn"
            onClick={() => (window.location.href = 'https://mocktest.futuremedsacademy.com/pricing')}
          >
            Enroll Now
          </button>
        </div>

      </div>

      <div className="study-container">
        <div className="study-content">
          <p className="study-subtitle">Master IMAT Chemistry with Toranj Maleki
          </p>
          <h1 className="study-title">
            <span className="highlight">Chemistry</span>
          </h1>
          <p className="study-subtitle">Why Choose Our Chemistry Course?</p>
          <h1><b>Learn from an IMAT Top Scorer & Ace Chemistry with Confidence
            Chemistry plays a crucial role in the IMAT exam, and having the right mentor can make all the difference.

          </b></h1>

          <p><b>With a remarkable score of 72.4 in IMAT, Toranj Maleki has mastered the strategies needed to excel in this subject. Now, she is here to guide you through the most effective techniques to solve Chemistry questions quickly and accurately.




          </b></p>
          <ul className="study-list">
            <li>✔ <b>Learn from a High Scorer – Toranj Maleki’s IMAT 72.4 score proves she knows exactly how to tackle tricky chemistry questions.

            </b></li>
            <li>✔ <b> IMAT-Specific Approach – Focus on high-yield topics that are repeatedly tested in the exam.

            </b></li>
            <li>✔ <b>  Speed & Accuracy Techniques – Master shortcuts, problem-solving tricks, and time-saving strategies.
            </b></li>
            <li>✔ <b> Interactive & Engaging Teaching – Complex chemistry concepts are broken down into simple, easy-to-understand lessons.
            </b></li>
            <li>✔ <b>  Recorded Lectures for Revision – Access all sessions anytime, available only for Plus & Premium students.
            </b></li>
          </ul>
          <button
            className="btn"
            id="loginBtn"
            onClick={() => (window.location.href = 'https://mocktest.futuremedsacademy.com/pricing')}
          >
            Enroll Now
          </button>
        </div>
        <div className="study-image">
          <img src={cnotes} alt="Study Session" />
        </div>
      </div>

      <div className="study-container">
        <div className="study-image">
          <img src={mnotes} alt="Study Session" />
        </div>
        <div className="study-content">
          <p className="study-subtitle">Master IMAT Mathematics with Nazanin & Hayk Sarsyan

          </p>
          <h1 className="study-title">
            <span className="highlight">Maths</span>
          </h1>
          <p className="study-subtitle">Learn from Experts in Olympiad Mathematics & Programming!
          </p>
          <h1><b>Mathematics is a game-changer in the IMAT exam, and having the right mentors can transform your score.


          </b></h1>

          <p><b>With Nazanin, an Olympiad-level Mathematics expert, and Hayk Sarsyan, a programming and logic specialist, you’ll get the best of both worlds—deep conceptual understanding and logical problem-solving skills that give you an edge.




          </b></p>
          <ul className="study-list">
            <li>✔ <b>Nazanin: A Mathematics Olympiad Expert – Learn from an elite problem solver.


            </b></li>
            <li>✔ <b> Hayk Sarsyan: A Programming & Logical Thinking Specialist – Sharpen your reasoning skills.


            </b></li>
            <li>✔ <b>  Master Every IMAT Math Topic – Covering algebra, probability, calculus, and logic in depth.

            </b></li>
            <li>✔ <b> Easy-to-Understand Explanations – No more struggling with complex equations.

            </b></li>
            <li>✔ <b>  Strategy-Based Learning – Solve questions faster & more efficiently.

            </b></li>

            <li>✔ <b>  Live & Recorded Lessons – Learn at your own pace.

            </b></li>
          </ul>
          <button
            className="btn"
            id="loginBtn"
            onClick={() => (window.location.href = 'https://mocktest.futuremedsacademy.com/pricing')}
          >
            Enroll Now
          </button>
        </div>

      </div>

      <div className="study-container">

        <div className="study-content">
          <p className="study-subtitle">Master Logical Reasoning & General Knowledge for IMAT with Aamir Akhtar


          </p>
          <h1 className="study-title">
            <span className="highlight">Logical Reasoning & General Knowledge</span>
          </h1>
          <p className="study-subtitle"> Sharpen Your Thinking & Ace the IMAT Exam!

          </p>
          <h1><b>Logical Reasoning & General Knowledge are crucial for IMAT success, and with Aamir Akhtar’s expertly crafted lessons, you’ll build the skills & confidence needed to tackle even the toughest questions.




          </b></h1>

          <p><b>His structured approach ensures that you think critically, solve problems quickly, and stay updated with essential GK topics.



          </b></p>
          <ul className="study-list">
            <li>✔ <b>Comprehensive Video Lessons – Covering syllogisms, assumptions, deductions, pattern recognition, and data interpretation.



            </b></li>
            <li>✔ <b> Proven IMAT Strategies – Learn quick tricks & logical shortcuts to save time in the exam.



            </b></li>
            <li>✔ <b>  Real Exam-Style Questions & Solutions – Practice with past papers & high-yield problems.


            </b></li>
            <li>✔ <b> Step-by-Step Problem Solving – Understand the logic behind every answer.

            </b></li>
            <li>✔ <b>  Interactive Practice & Mock Tests – Apply concepts in a real exam-like environment.

            </b></li>


          </ul>
          <button
            className="btn"
            id="loginBtn"
            onClick={() => (window.location.href = 'https://mocktest.futuremedsacademy.com/pricing')}
          >
            Enroll Now
          </button>
        </div>
        <div className="study-image">
          <img src={rnotes} alt="Study Session" />
        </div>

      </div>
    </>
  );
};

export default ImatCourse;